module.exports = __webpack_public_path__ + "static/media/screen-primary-04.333d5dcc.jpg";